import React from "react";

interface CustomPopoverProps {
  open: boolean;
  children: React.ReactNode;
}

const CustomPopover: React.FC<CustomPopoverProps> = ({ open, children }) => {
  if (!open) {
    return null;
  }

  return (
    <div
      style={{
        position: "absolute",
        top: "56px",
        left: 0,
        width: "100%",
        overflow: "hidden",
        zIndex: 1300, // Higher than sidebar (1200) and other content
        paddingBottom: "40px",
      }}
    >
      {children}
    </div>
  );
};

export default CustomPopover;
